// extracted by mini-css-extract-plugin
export default {"invoicesSendMail":"styles_invoicesSendMail__06BSM"};